export default __webpack_public_path__ + "static/media/flag-mexico.0150ae22.svg";